// The last crumb names what is open. A page that is showing one record (a contact, a company, a partner, a team member) calls useCrumbTitle('Randy Frederick') and the breadcrumb ends with that name;
// when the record closes (or the page goes away) the title clears itself. `replace` is for a page that IS the record (Partner Profile, Team Member): the name takes the place of the page's own label
// instead of being added after it.
import { useEffect, useSyncExternalStore } from 'react';

let state = { title: null, replace: false };
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());
const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };
const snapshot = () => state;

export function setCrumbTitle(title, replace = false) {
  const next = title ? { title: String(title), replace: !!replace } : { title: null, replace: false };
  if (next.title === state.title && next.replace === state.replace) return;
  state = next;
  emit();
}

export function useCrumbTitle(title, { replace = false } = {}) {
  useEffect(() => {
    setCrumbTitle(title, replace);
    return () => setCrumbTitle(null);
  }, [title, replace]);
}

export const useCurrentCrumbTitle = () => useSyncExternalStore(subscribe, snapshot, snapshot);

// The crumbs with the title applied: appended, or replacing the last label.
export function withCrumbTitle(crumbs, current) {
  if (!current || !current.title || crumbs.length === 0) return crumbs;
  if (current.replace) return [...crumbs.slice(0, -1), { ...crumbs[crumbs.length - 1], label: current.title }];
  return [...crumbs, { key: '__title__', label: current.title, title: true }];
}
